module.exports = __webpack_public_path__ + "img/pic_card3@2x.8cca4a2a.png";